import React, { Component } from 'react'
import { GetData } from '../../../api/service'
import { Typography, Table, TableHead, TableRow, TableCell, TableBody, Button } from '@material-ui/core'
import Edit from '@material-ui/icons/Edit'

export default class FacilityLanding extends Component {
    state = {
        list: [],
        isLoaded: false
    }

    componentDidMount() {
        GetData(`/${this.props.apikey}/getfacility`)
            .then((resp) => {
                this.setState({
                    list: resp,
                    isLoaded: true
                })
            })
    }

    render() {
        return (
            <div>
                <Typography variant="h6">
                    Facilities
            </Typography>

                <div align="right">
                    <Button variant="contained" color="primary" onClick={() => this.props.history.push('/facility/add')}>
                        Add Facility
            </Button>
                </div>
                <br />
                <Table size="small" style={{backgroundColor: '#fff'}}>

                    <TableHead>
                        <TableRow>
                            <TableCell width="5%">#</TableCell>
                            <TableCell width="15%">Dept Code</TableCell>
                            <TableCell width="65%">Facility</TableCell>
                            <TableCell width="5%">Edit</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.state.list.map((el, index) =>
                            <TableRow key={index} style={{ verticalAlign: 'top' }}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{el.dept_code}</TableCell>
                                <TableCell dangerouslySetInnerHTML={{ __html: el.facility }}></TableCell>


                                <TableCell><Edit onClick={() => this.props.history.push('/facility/edit', el)} /></TableCell>
                            </TableRow>
                        )}
                    </TableBody>

                </Table>


            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Components/Department/Facility/FacilityLanding.js